import { GoalThreshold } from '../../../coaching-base/config';
import {
    FocusDto,
    FocusForPerformerCoachableMetric,
    FocusForPerformerFocusHistory,
    FocusForPerformerPopulationFocus,
} from '../../../coaching-base/general';
import { GoalsCollection } from '../../../coaching-commitment/goals-collection.model';
import { createAction } from '../../../store.model';
import { ActionType } from '../focus-selector.action';
import { FocusSelectorMetricModel } from '../model/focus-selector-metric.model';
import { FocusSelectorTriggerSource } from '../model/focus-selector-trigger-source.enum';

export interface FocusSelectorInit {
    coachId: number;
    performerId: number;
    activeMetricId: FocusSelectorMetricModel['id'];
    selectedFocus: FocusDto;
    goalsCollection: GoalsCollection;
    triggerSource: FocusSelectorTriggerSource;
    commitmentId: number;
}

export const focusSelectorInit = createAction<ActionType, FocusSelectorInit>(
    ActionType.COACHING_FOCUS_SELECTOR__INIT,
);

export interface FocusSelectorInitResult {
    coachId: number;
    performerId: number;
    commitmentId: number;
    initSelectedFocus: FocusDto;

    active: FocusForPerformerFocusHistory[];
    closed: FocusForPerformerFocusHistory[];

    other: FocusForPerformerFocusHistory[];

    teamActive: FocusForPerformerFocusHistory[];
    teamClosed: FocusForPerformerFocusHistory[];

    coachableMetrics: FocusForPerformerCoachableMetric[];
    userBehaviours: FocusForPerformerPopulationFocus[];

    goalThresholds: GoalThreshold[];
}

export const focusSelectorInitResultMain = createAction<
    ActionType,
    FocusSelectorInitResult
>(ActionType.COACHING_FOCUS_SELECTOR__INIT_RESULT);
